import React from "react";
import { TrendingUp, Users, Calendar, Clock, Activity } from "lucide-react";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

export default function AdminDashboard() {
  // Mock data - replace with your API
  const hourlyData = [
    { time: "6-9", bookings: 6 },
    { time: "9-12", bookings: 14 },
    { time: "12-15", bookings: 10 },
    { time: "15-18", bookings: 16 },
    { time: "18-21", bookings: 12 },
    { time: "21-24", bookings: 8 },
  ];

  const therapistLoad = [
    { name: "Priya", load: 18, max: 20, color: "bg-[#0B2A2C]" },
    { name: "Anil", load: 14, max: 20, color: "bg-[#0B2A2C]" },
    { name: "Meera", load: 16, max: 20, color: "bg-[#0B2A2C]" },
    { name: "Rohan", load: 11, max: 20, color: "bg-[#0B2A2C]" },
    { name: "Sonia", load: 19, max: 20, color: "bg-[#0B2A2C]" },
  ];


  return (
    <div className="bg-[#E5D8C2] rounded-2xl min-h-screen p-6 space-y-8">
      {/* Header */}
      <div>
        <h2 className="text-4xl font-bold text-gray-800">Admin Dashboard</h2>
        <p className="text-gray-600 mt-2">Real-time insights into bookings, therapists & performance</p>
      </div>

      {/* Interactive Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-gradient-to-br bg-[#0B2A2C] p-6 rounded-2xl shadow-xl text-white transform hover:scale-105 transition-all duration-300">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-green-100">Total Bookings</p>
              <p className="text-4xl font-bold mt-2">140+</p>
              <div className="flex items-center mt-3 gap-2">
                <TrendingUp className="w-5 h-5" />
                <span className="text-sm">+12% from last week</span>
              </div>
            </div>
            <Calendar className="w-12 h-12 opacity-80" />
          </div>
        </div>

        <div className="bg-gradient-to-br bg-[#0B2A2C] p-6 rounded-2xl shadow-xl text-white transform hover:scale-105 transition-all duration-300">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-blue-100">Active Therapists</p>
              <p className="text-4xl font-bold mt-2">22</p>
              <div className="flex items-center mt-3 gap-2">
                <Activity className="w-5 h-5" />
                <span className="text-sm">2 on leave today</span>
              </div>
            </div>
            <Users className="w-12 h-12 opacity-80" />
          </div>
        </div>

        <div className="bg-gradient-to-br bg-[#0B2A2C] p-6 rounded-2xl shadow-xl text-white transform hover:scale-105 transition-all duration-300">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-purple-100">Users Registered</p>
              <p className="text-4xl font-bold mt-2">520+</p>
              <div className="flex items-center mt-3 gap-2">
                <TrendingUp className="w-5 h-5" />
                <span className="text-sm">+42 this week</span>
              </div>
            </div>
            <Users className="w-12 h-12 opacity-80" />
          </div>
        </div>
      </div>

      {/* Reports Overview - Now Interactive */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Therapist Workload Heatmap */}
        <div className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100">
          <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
            <Activity className="w-7 h-7 text-purple-600" />
            Therapist Workload Today
          </h3>
          <div className="space-y-4">
            {therapistLoad.map((t) => (
              <div key={t.name} className="flex items-center gap-4">
                <div className="w-24 text-sm font-medium text-gray-700">{t.name}</div>
                <div className="flex-1 bg-gray-200 rounded-full h-10 relative overflow-hidden">
                  <div
                    className={`${t.color} h-full rounded-full flex items-center justify-end pr-4 text-white font-bold transition-all duration-700`}
                    style={{ width: `${(t.load / t.max) * 100}%` }}
                  >
                    {t.load}
                  </div>
                </div>
                <span className="text-sm text-gray-500 w-16 text-right">
                  {t.load}/{t.max}
                </span>
              </div>
            ))}
          </div>
          <div className="mt-6 p-4 bg-orange-50 rounded-lg border border-orange-200">
            <p className="text-orange-800 font-medium">Sonia & Priya are at 90%+ capacity!</p>
          </div>
        </div>

        {/* Hourly Booking Heatmap */}
        <div className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100">
          <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
            <Clock className="w-7 h-7 text-blue-600" />
            Hourly Bookings Today
          </h3>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={hourlyData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="time" />
                <YAxis />
                <Tooltip
                  contentStyle={{ background: "#d4aa82ff", border: "none", borderRadius: "8px" }}
                  labelStyle={{ color: "#0B2A2C" }}
                />
                <Bar dataKey="bookings" fill="#0B2A2C" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div className="mt-4 text-sm text-gray-600">
            Peak hours: <span className="font-bold text-purple-600">3 PM - 6 PM</span> (16 bookings)
          </div>
        </div>
      </div>

      {/* Daily Bookings Report - Supercharged */}
<div className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100">
  <h2 className="text-3xl font-bold text-gray-800 mb-8">Daily Bookings Report</h2>

  {/* Summary Cards – Updated with real metrics */}
  <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-10">
    <div className="bg-gradient-to-br hover:scale-105 bg-[#0B2A2C] p-6 rounded-xl text-white shadow-lg">
      <p className="text-sm opacity-90">Today</p>
      <p className="text-4xl font-bold mt-2">38</p>
      <p className="text-xs mt-1 flex items-center gap-1">
        <TrendingUp className="w-4 h-4" /> +8 vs yesterday
      </p>
    </div>

    <div className="bg-gradient-to-br bg-[#0B2A2C] p-6 rounded-xl text-white shadow-lg">
      <p className="text-sm opacity-90">This Week</p>
      <p className="text-4xl font-bold mt-2">218</p>
    </div>

    <div className="bg-gradient-to-br hover:scale-105 bg-[#0B2A2C] p-6 rounded-xl text-white shadow-lg">
      <p className="text-sm opacity-90">This Month</p>
      <p className="text-4xl font-bold mt-2">842</p>
    </div>

    <div className="bg-gradient-to-br hover:scale-105 bg-[#0B2A2C] p-6 rounded-xl text-white shadow-lg">
      <p className="text-sm opacity-90">Revenue Today</p>
      <p className="text-4xl font-bold mt-2">₹68.5k</p>
    </div>
  </div>

  {/* Today's Bookings Table */}
  <div className="overflow-x-auto rounded-xl border border-gray-200 mb-10">
    <table className="w-full text-sm text-left">
      <thead className="bg-gray-50 text-xs uppercase text-gray-600">
        <tr>
          <th className="px-6 py-4">Client Name</th>
          <th className="px-6 py-4">Time</th>
          <th className="px-6 py-4">Treatment</th>
          <th className="px-6 py-4">Therapist</th>
          <th className="px-6 py-4">Status</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-100">
        {[
          { name: "Priya Sharma", time: "10:30 AM", treatment: "Ayurvedic Massage", therapist: "Anil", status: "Confirmed" },
          { name: "Rahul Verma", time: "11:00 AM", treatment: "Shirodhara", therapist: "Waiting", status: "Waiting" },
          { name: "Neha Kapoor", time: "12:15 PM", treatment: "Panchakarma", therapist: "Meera", status: "Confirmed" },
          { name: "Amit Singh", time: "02:30 PM", treatment: "Abhyanga", therapist: "Priya", status: "Confirmed" },
          { name: "Sonia Reddy", time: "04:00 PM", treatment: "Yoga Therapy", therapist: "Waiting", status: "Waiting" },
        ].map((b, i) => (
          <tr key={i} className="hover:bg-gray-50 transition">
            <td className="px-6 py-4 font-medium">{b.name}</td>
            <td className="px-6 py-4">{b.time}</td>
            <td className="px-6 py-4 text-indigo-700 font-medium">{b.treatment}</td>
            <td className="px-6 py-4">
              {b.therapist === "Waiting" ? (
                <span className="inline-flex px-3 py-1 text-xs font-medium rounded-full bg-orange-100 text-orange-800">
                  Waiting List
                </span>
              ) : (
                b.therapist
              )}
            </td>
            <td className="px-6 py-4">
              <span className={`inline-flex px-3 py-1 text-xs font-medium rounded-full ${
                b.status === "Confirmed" 
                  ? "bg-green-100 text-green-800" 
                  : "bg-yellow-100 text-yellow-800"
              }`}>
                {b.status}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Monthly Revenue Line Graph */}
  <div className="bg-[#EBE0CF] p-8 rounded-2xl">
    <h3 className="text-2xl font-bold text-gray-800 mb-6">Revenue Trend – Last 30 Days</h3>
    
    <div className="grid grid-cols-3 gap-6 mb-6 text-center">
      <div className="bg-white hover:scale-105 p-4 rounded-xl shadow">
        <p className="text-gray-600 text-sm">Weekly</p>
        <p className="text-2xl font-bold text-[#0B2A2C]">₹4.82L</p>
      </div>
      <div className="bg-white hover:scale-105 p-4 rounded-xl shadow">
        <p className="text-gray-600 text-sm">Monthly</p>
        <p className="text-2xl font-bold text-[#0B2A2C]">₹18.6L</p>
      </div>
      <div className="bg-white hover:scale-105 p-4 rounded-xl shadow">
        <p className="text-gray-600 text-sm">Avg/Client</p>
        <p className="text-2xl font-bold text-[#0B2A2C]">₹1,802</p>
      </div>
    </div>

    <div className="h-80">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={[
          { date: "1 Nov", revenue: 420000 },
          { date: "5 Nov", revenue: 458000 },
          { date: "10 Nov", revenue: 512000 },
          { date: "15 Nov", revenue: 498000 },
          { date: "20 Nov", revenue: 635000 },
          { date: "24 Nov", revenue: 685000 },
        ]}>
          <CartesianGrid strokeDasharray="5 5" />
          <XAxis dataKey="date" />
          <YAxis tickFormatter={(value) => `₹${(value/100000).toFixed(1)}L`} />
          <Tooltip formatter={(value) => `₹${(value/1000).toFixed(1)}k`} />
          <Line type="monotone" dataKey="revenue" stroke="#0B2A2C" strokeWidth={5} dot={{ r: 6 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  </div>
</div>
    </div>
  );
}